import React, { useEffect, useState } from 'react'
import './Payroll.scss'
import { salaryService } from 'Services/salaryService'
import { CurrencyFormatter } from 'Helpers'
import { ModalWrapper } from 'Components'
import EMoney from 'Assets/Images/e-money.png'
import BankIcon from 'Assets/Images/bank.png'
import HashIcon from 'Assets/Images/hash.png'
import DollarIcon from 'Assets/Images/chair-dollar.png'
import TinIcon from 'Assets/Images/nin-like.png'
import FlagIcon from 'Assets/Images/residence-like.png'
import PensionUpdate from './Modals/PensionUpdate/PensionUpdate'
import BankUpdate from './Modals/BankUpdate/BankUpdate'
import TaxUpdate from './Modals/TaxUpdate/TaxUpdate'
import { maskAccount } from 'Helpers/MaskedAccount'
import { EmployeeSingleType } from 'Models/employeeType'
import { Link } from 'react-router-dom'

type Props = {
  profile: EmployeeSingleType | null | undefined
  setProfile: any
}

const Payroll = ({ profile, setProfile }: Props) => {
  const [netPay, setNetPay] = useState<number>()
  const [basicEarnings, setBasicEarnings] = useState<number>()
  const [leaveAllowance, setLeaveAllowance] = useState<number>()

  const getSalary = async () => {
    await salaryService.getEmployeeSalary().then((response) => {
      // console.log('getSalary response', response.data.data)

      const dataset = response.data.data

      const earning = response.data.data.earnings
      const deduction = response.data.data.deductions
      const allowance = response.data.data.allowances

      const totalEarnings = earning.reduce(
        (sum: number, item: { amount: number }) => sum + item.amount,
        0,
      )

      const totalDeductions = deduction.reduce(
        (sum: number, item: { amount: number }) => sum + item.amount,
        0,
      )

      // console.log({ totalEarnings })
      // setNetPay(totalEarnings - totalDeductions)
      setNetPay(dataset.length > 0 || dataset !== undefined ? dataset?.netPay : '0.00')

      const basic = earning.find((item: any) => item.category === 'Basic Salary')
      const leave = allowance.find((item: any) => item.category === 'Leave Allowance')

      setBasicEarnings(basic ? basic.amount : 0)
      setLeaveAllowance(leave?.amount ?? 0)
    })
  }

  useEffect(() => {
    getSalary()
  }, [])

  const [showModal, setShowModal] = useState(false)
  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const [showModalPension, setShowModalPension] = useState(false)
  const toggleModalPension = () => {
    setShowModalPension((prevState) => !prevState)
  }

  const [showModalTax, setShowModalTax] = useState(false)
  const toggleModalTax = () => {
    setShowModalTax((prevState) => !prevState)
  }

  return (
    <div className='payroll-info'>
      <div className='container-fluid m-0 p-0 salaryAllowance'>
        <div className='row g-4'>
          <div className='col-lg-6'>
            <div className='card'>
              <div className='card-body d-flex justify-content-between mt-2'>
                <div className='salary'>
                  <h6>Net Pay</h6>
                  <h2 className='mt-3'>₦{CurrencyFormatter(Number(netPay))}</h2>
                </div>
                <div className='img-con'>
                  <img src={EMoney} alt='icon' />
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='card'>
              <div className='card-body mt-2 d-flex justify-content-between align-items-center'>
                <div className='salary'>
                  <h6>Leave Allowance</h6>
                  <h2 className='mt-3'>₦{CurrencyFormatter(Number(leaveAllowance))}</h2>
                </div>
                <div className='profile-action'>
                  <Link to={'/payroll'}>
                    <button className='btn'>View</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='container-fluid mt-4 p-0 statutory'>
        <div className='row g-4'>
          <div className='col-lg-4'>
            <div className='card'>
              <div className='card-body mt-2'>
                <div className='bank-details-h line'>
                  <h6 className='heading'>bank details</h6>
                </div>
                <div className='bank-details line'>
                  <div className='icon-head'>
                    <img src={BankIcon} alt='' />
                    <h6>Bank</h6>
                  </div>
                  <h6
                    className={`${profile?.bankName === null || profile?.bankName === 'string' ? 'sub-not' : 'sub'} `}
                  >
                    {profile?.bankName === 'string' || profile?.bankName === null
                      ? 'Not Provided'
                      : profile?.bankName}
                  </h6>{' '}
                </div>
                <div className='bank-details'>
                  <div className='icon-head'>
                    <img src={HashIcon} alt='' />
                    <h6>Account Number</h6>
                  </div>
                  <h6
                    className={`${profile?.bankAccountNumber === null || profile?.bankAccountNumber === 'string' ? 'sub-not' : 'sub'} `}
                  >
                    {profile?.bankAccountNumber === 'string' || profile?.bankAccountNumber === null
                      ? 'Not Provided'
                      : maskAccount(profile?.bankAccountNumber)}
                  </h6>{' '}
                </div>

                <p className='others'>Account number is masked for security reasons.</p>

                <button onClick={toggleModal} type='button'>
                  Request Change
                </button>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='card'>
              <div className='card-body mt-2'>
                <div className='bank-details-h line'>
                  <h6 className='heading'>Pension Details</h6>
                </div>
                <div className='bank-details line'>
                  <div className='icon-head'>
                    <img src={DollarIcon} alt='icon' />
                    <h6>PFA</h6>
                  </div>
                  <h6 className={`${profile?.pfa === null ? 'sub-not' : 'sub'} `}>
                    {profile?.pfa ?? 'Not Provided'}
                  </h6>
                </div>
                <div className='bank-details'>
                  <div className='icon-head'>
                    <img src={HashIcon} alt='' />
                    <h6>RSA Number</h6>
                  </div>
                  <h6 className={`${profile?.rsaNumber === null ? 'sub-not' : 'sub'} `}>
                    {profile?.rsaNumber ?? 'Not Provided'}
                  </h6>{' '}
                </div>

                <p className='others'>Retirement Savings Account number issued by your PFA.</p>

                <button onClick={toggleModalPension} type='button'>
                  Update Pension Details
                </button>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='card'>
              <div className='card-body mt-2'>
                <div className='bank-details-h line'>
                  <h6 className='heading'>Tax Details</h6>
                </div>
                <div className='bank-details line'>
                  <div className='icon-head'>
                    <img src={TinIcon} alt='' />
                    <h6>Tax ID (TIN)</h6>
                  </div>
                  <h6 className={`${profile?.taxId === null ? 'sub-not' : 'sub'} `}>
                    {profile?.taxId ?? 'Not Provided'}
                  </h6>{' '}
                </div>
                <div className='bank-details'>
                  <div className='icon-head'>
                    <img src={FlagIcon} alt='' />
                    <h6>Residential State</h6>
                  </div>
                  <h6 className={`${profile?.state === null ? 'sub-not' : 'sub'} `}>
                    {profile?.state ?? 'Not Provided'}
                  </h6>{' '}
                </div>

                <p className='others'>
                  Tax deductions are calculated based on your state of residence.
                </p>

                <button onClick={toggleModalTax} type='button'>
                  Update Tax Details
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='footer'>
        <span>Last updated: NA</span>
        <span>Updated by: NA</span>
      </div>

      <ModalWrapper
        showModal={showModal}
        closeModal={toggleModal}
        title={<span className='custom-modal-title'> Bank Details</span>}
      >
        <BankUpdate
          profile={profile}
          setProfile={setProfile}
          toggleModal={toggleModal}
        ></BankUpdate>
      </ModalWrapper>

      <ModalWrapper
        showModal={showModalPension}
        closeModal={toggleModalPension}
        title={<span className='custom-modal-title'>Pension Details</span>}
      >
        <PensionUpdate
          profile={profile}
          setProfile={setProfile}
          toggleModal={toggleModalPension}
        ></PensionUpdate>
      </ModalWrapper>

      <ModalWrapper
        showModal={showModalTax}
        closeModal={toggleModalTax}
        title={<span className='custom-modal-title'>Tax Details</span>}
      >
        <TaxUpdate
          profile={profile}
          setProfile={setProfile}
          toggleModal={toggleModalTax}
        ></TaxUpdate>
      </ModalWrapper>
    </div>
  )
}

export default Payroll
